import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { BonusCover } from './BonusCover';
export function Bonuses() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-26" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="aua4k7ni97qe">
        <div className="text-center" data-id="element-28" data-mp="fu6d8k75dnca">
          <h2 className="font-display text-[1.9rem] font-extrabold leading-tight tracking-tight text-navy sm:text-[2.8rem]" data-id="element-29" data-mp="ft4oxe14f4cm">
            <span aria-hidden="true" data-id="element-30" data-mp="1t3o1ykuvwx5">🎁 </span>5 exklusive Bonus-Pakete
          </h2>
          <p className="mt-4 text-base text-navy/70" data-id="element-31" data-mp="5wrvmh9hmsie">
            Gesamtwert <span className="font-bold text-navy line-through decoration-cherry decoration-2" data-id="element-32" data-mp="3o24wk676k5wf">116 €</span>{' '}
            — heute{' '}
            <span className="rounded-md bg-leaf px-2 py-0.5 font-bold text-white" data-id="element-33" data-mp="3t183jw6q0m71">GRATIS</span> im
            Preis enthalten
          </p>
        </div>

        <ol className="mt-12 space-y-5" data-id="element-34" data-mp="1r931vszf6aj4">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid items-center gap-6 rounded-3xl bg-ice p-6 sm:grid-cols-[auto_1fr] sm:gap-10 sm:p-8" data-id="element-35" data-mp="3ieg9h9e6kh3h" data-mpi={index}>
              <BonusCover number={index + 1} label={bonus.coverLabel} color={bonus.cover} data-id="element-36" data-mp="3dd90j70axbv8" />

              <div className="min-w-0" data-id="element-37" data-mp="3r5ylr980acra">
                <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-navy sm:text-2xl" data-id="element-38" data-mp="3n5etaiydnxbh">
                  {bonus.title}
                </h3>
                {bonus.lead && <p className="mt-2 font-display text-lg font-bold text-brand" data-id="element-39" data-mp="2uh0s5ubzskvp">{bonus.lead}</p>}
                {bonus.levels && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-40" data-mp="38hjworh918t4">
                    {bonus.levels.map(level => <li key={level.label} className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-navy" data-id="element-41" data-mp="33j9ye8089s3a">
                        <span className={`h-2.5 w-2.5 rounded-full ${level.dot}`} aria-hidden="true" data-id="element-42" data-mp="3cjpnsxu9esnk" />
                        {level.label}
                      </li>)}
                  </ul>}
                <p className="mt-3 text-[15px] leading-relaxed text-navy/75" data-id="element-43" data-mp="3lk4bg3up4ju8">{bonus.text}</p>
                {bonus.quote && <p className="mt-3 border-l-4 border-sun pl-3 text-[15px] font-semibold text-navy" data-id="element-44" data-mp="3qgbjq3ake7fc">
                    {bonus.quote}
                  </p>}
                {bonus.steps && <ol className="mt-4 flex flex-wrap gap-2" data-id="element-45" data-mp="32t3h5t4itch0">
                    {bonus.steps.map((step, stepIndex) => <li key={step} className="inline-flex items-center gap-2 rounded-xl bg-navy px-3 py-2 font-display text-sm font-extrabold text-white" data-id="element-46" data-mp="37k3cwv1wlohx" data-mpi={stepIndex}>
                        <span className="text-sun" data-id="element-47" data-mp="2f1y0xcuo4i66">{stepIndex + 1}</span>
                        {step}
                      </li>)}
                  </ol>}
                {bonus.features.length > 0 && <ul className="mt-4 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-48" data-mp="1xltul55jer4y">
                    {bonus.features.map(feature => <li key={feature} className="flex items-center gap-2 text-sm font-medium text-navy/85" data-id="element-49" data-mp="1tj6xopu0eg0w">
                        <CheckIcon className="h-4 w-4 shrink-0 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-50" data-mp="1olxcxnhkesje" />
                        {feature}
                      </li>)}
                  </ul>}
                <p className="mt-5 inline-flex items-center gap-2 rounded-lg bg-white px-3 py-1.5 text-sm font-bold" data-id="element-51" data-mp="1et9hox68gwms">
                  <span className="text-navy/60 line-through decoration-cherry decoration-2" data-id="element-52" data-mp="15unzx48l5ln2">
                    Wert {bonus.was}
                  </span>
                  <span className="text-leaf" data-id="element-53" data-mp="10w31998zfa0q">— GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}